import lang from '@/lang'
import adminConfig from '@/modules/admin/config'
import { user } from 'ampersand-app'
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import TimeoutLoader from '@/modules/base/components/loader/loader-with-timeout'
import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'

const ADMIN_LOGIN_TIMEOUT_MS = 30000

const LoginToken = () => {
  const navigate = useNavigate()
  const { token } = useParams()

  useEffect(() => {
    // Set loginInProgress flag and clear old token to prevent race condition
    user.setLoginInProgress(true)

    request(adminConfig.endpoints.loginWithToken, {
      method: 'POST',
      data: { token },
    })
      .then((response) => {
        return user.login(response.body)
      })
      .catch((response) => {
        const { xhr } = response

        if (!xhr) return

        const { body: { meta: { token: [{ code }] } } } = response
        if (code === 'INVALID') {
          toast.showToast({ type: 'error', message: lang.messages.common.tokenInvalid })
        }
      })
      .finally(() => {
        // must be cleared before navigating, otherwise the dashboard renders a loader forever
        // when the request above failed and user.login was never reached
        user.setLoginInProgress(false)
        navigate('/dashboard')
      })
  }, [])

  return <TimeoutLoader timeoutMs={ADMIN_LOGIN_TIMEOUT_MS} />
}

export default LoginToken
